import React, { useEffect, useMemo, useState } from "react";
import "./AppV2.css";
import logo from "../AppiHolidays Branding.png";

const SAMPLE_DESTINATIONS = [
  {
    city: "Paris",
    country: "France",
    region: "Europe",
    vibe: "Landmarks, cafes, and classic boulevards",
    image: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "London",
    country: "United Kingdom",
    region: "Europe",
    vibe: "Museums, markets, and iconic skyline",
    image: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Rome",
    country: "Italy",
    region: "Europe",
    vibe: "Ancient history and street life",
    image: "https://images.unsplash.com/photo-1552832230-c0197dd311b5?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Bangkok",
    country: "Thailand",
    region: "Asia",
    vibe: "Temples, night markets, and flavor",
    image: "https://images.unsplash.com/photo-1508009603885-50cf7c579365?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Dubai",
    country: "United Arab Emirates",
    region: "Asia",
    vibe: "Skyline luxury and beach escapes",
    image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Singapore",
    country: "Singapore",
    region: "Asia",
    vibe: "Sky gardens, food halls, and waterfront lights",
    image: "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Tokyo",
    country: "Japan",
    region: "Asia",
    vibe: "Neon streets, temples, and precision culture",
    image: "https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "New York City",
    country: "United States",
    region: "Americas",
    vibe: "Broadway lights, skyline views, and nonstop energy",
    image: "https://images.unsplash.com/photo-1496588152823-86ff7695e68f?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Barcelona",
    country: "Spain",
    region: "Europe",
    vibe: "Beach city energy and Gaudi architecture",
    image: "https://images.unsplash.com/photo-1583422409516-2895a77efded?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Amsterdam",
    country: "Netherlands",
    region: "Europe",
    vibe: "Canals, bikes, and vibrant neighborhoods",
    image: "https://images.unsplash.com/photo-1534351590666-13e3e96b5017?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Istanbul",
    country: "Turkey",
    region: "Europe",
    vibe: "Bosphorus views, bazaars, and layered history",
    image: "https://images.unsplash.com/photo-1527838832700-5059252407fa?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Hong Kong",
    country: "Hong Kong",
    region: "Asia",
    vibe: "Harbor skyline, markets, and mountain tram views",
    image: "https://images.unsplash.com/photo-1536599018102-9f803c140fc1?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Kuala Lumpur",
    country: "Malaysia",
    region: "Asia",
    vibe: "Petronas skyline, street food, and tropical pace",
    image: "https://images.unsplash.com/photo-1570641963303-92ce4845ed4c?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Seoul",
    country: "South Korea",
    region: "Asia",
    vibe: "Palaces, design districts, and night food alleys",
    image: "https://images.unsplash.com/photo-1538485399081-7c897f6dfe1c?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Los Angeles",
    country: "United States",
    region: "Americas",
    vibe: "Beach drives, studio culture, and palm boulevards",
    image: "https://images.unsplash.com/photo-1534190760961-74e8c1c5c3da?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Las Vegas",
    country: "United States",
    region: "Americas",
    vibe: "Resort lights, shows, and desert escapes",
    image: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Prague",
    country: "Czechia",
    region: "Europe",
    vibe: "Storybook lanes and river views",
    image: "https://images.unsplash.com/photo-1541849546-216549ae216d?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Vienna",
    country: "Austria",
    region: "Europe",
    vibe: "Imperial streets, music, and coffee houses",
    image: "https://images.unsplash.com/photo-1516550893923-42d28e5677af?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Sydney",
    country: "Australia",
    region: "Australia",
    vibe: "Harbor life and coastal walks",
    image: "https://images.unsplash.com/photo-1528072164453-f4e8ef0d475a?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Lisbon",
    country: "Portugal",
    region: "Europe",
    vibe: "Sun, coast, and old-town streets",
    image: "https://images.unsplash.com/photo-1585208798174-6cedd86e019a?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Bali",
    country: "Indonesia",
    region: "Asia",
    vibe: "Rice terraces, beaches, and temple sunsets",
    image: "https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Dublin",
    country: "Ireland",
    region: "Europe",
    vibe: "Georgian streets, pubs, and River Liffey walks",
    image: "https://images.unsplash.com/photo-1539635278303-d4002c07eae3?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Madrid",
    country: "Spain",
    region: "Europe",
    vibe: "Grand boulevards, tapas, and art museums",
    image: "https://images.unsplash.com/photo-1539037116277-4db20889f2d4?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Berlin",
    country: "Germany",
    region: "Europe",
    vibe: "History districts, modern art, and nightlife",
    image: "https://images.unsplash.com/photo-1560969184-10fe8719e047?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Athens",
    country: "Greece",
    region: "Europe",
    vibe: "Ancient landmarks and Mediterranean evenings",
    image: "https://images.unsplash.com/photo-1555993539-1732b0258235?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Venice",
    country: "Italy",
    region: "Europe",
    vibe: "Canals, palazzos, and romantic old-world streets",
    image: "https://images.unsplash.com/photo-1514890547357-a9ee288728e0?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Osaka",
    country: "Japan",
    region: "Asia",
    vibe: "Street food, neon canals, and castle history",
    image: "https://images.unsplash.com/photo-1590559899731-a382839e5549?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Kyoto",
    country: "Japan",
    region: "Asia",
    vibe: "Shrines, gardens, and traditional alleyways",
    image: "https://images.unsplash.com/photo-1492571350019-22de08371fd3?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Phuket",
    country: "Thailand",
    region: "Asia",
    vibe: "Island beaches, boat tours, and night markets",
    image: "https://images.unsplash.com/photo-1589394815804-964ed0be2eb5?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Ho Chi Minh City",
    country: "Vietnam",
    region: "Asia",
    vibe: "Cafe culture, boulevards, and river energy",
    image: "https://images.unsplash.com/photo-1528127269322-539801943592?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Mumbai",
    country: "India",
    region: "Asia",
    vibe: "Colonial landmarks, coast drives, and markets",
    image: "https://images.unsplash.com/photo-1595658658481-d53d3f999875?auto=format&fit=crop&w=900&q=80",
  },
  {
    city: "Abu Dhabi",
    country: "United Arab Emirates",
    region: "Asia",
    vibe: "Grand mosques, waterfront promenades, and luxury stays",
    image: "https://images.unsplash.com/photo-1512632578888-169bbbc64f33?auto=format&fit=crop&w=900&q=80",
  },
];

const REGION_ORDER = ["Europe", "Americas", "Asia", "Africa", "Australia"];

const ROOM_LIBRARY = [
  {
    id: "room-1",
    title: "Skyline Suite",
    area: "City Center",
    price: 149,
    rating: 8.9,
    budgetTag: "Mid-range",
    freeCancel: true,
    breakfast: true,
    tag: "Great for couples",
    image:
      "https://images.unsplash.com/photo-1560185007-c5ca9d2c014d?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "room-2",
    title: "Riverside Loft",
    area: "Old Quarter",
    price: 179,
    rating: 9.2,
    budgetTag: "Mid-range",
    freeCancel: true,
    breakfast: false,
    tag: "Top location",
    image:
      "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "room-3",
    title: "Boutique Garden Room",
    area: "Historic District",
    price: 79,
    rating: 8.6,
    budgetTag: "Budget",
    freeCancel: false,
    breakfast: true,
    tag: "Best value",
    image:
      "https://images.unsplash.com/photo-1590490360182-c33d57733427?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "room-4",
    title: "Grand Heritage Residence",
    area: "Embassy Quarter",
    price: 750,
    rating: 9.5,
    budgetTag: "Luxury",
    freeCancel: true,
    breakfast: true,
    tag: "Five-star experience",
    image:
      "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "room-5",
    title: "Harbor View Studio",
    area: "Waterfront",
    price: 69,
    rating: 8.3,
    budgetTag: "Budget",
    freeCancel: true,
    breakfast: false,
    tag: "Solo traveler favorite",
    image:
      "https://images.unsplash.com/photo-1616594039964-3f6f7f2f13b3?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "room-5b",
    title: "Old Quarter Guesthouse",
    area: "Old Quarter",
    price: 85,
    rating: 8.4,
    budgetTag: "Budget",
    freeCancel: true,
    breakfast: true,
    tag: "Charming low-cost stay",
    image:
      "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "room-5c",
    title: "City Budget Inn",
    area: "City Fringe",
    price: 99,
    rating: 8.1,
    budgetTag: "Budget",
    freeCancel: false,
    breakfast: false,
    tag: "Lowest nightly rate",
    image:
      "https://images.unsplash.com/photo-1484154218962-a197022b5858?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "room-5d",
    title: "Railway Rooms",
    area: "Station District",
    price: 72,
    rating: 8.2,
    budgetTag: "Budget",
    freeCancel: true,
    breakfast: false,
    tag: "Fast city access",
    image:
      "https://images.unsplash.com/photo-1522798514-97ceb8c4f1c8?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "room-5e",
    title: "Laneway Sleepbox",
    area: "Market Lanes",
    price: 62,
    rating: 8.0,
    budgetTag: "Budget",
    freeCancel: false,
    breakfast: true,
    tag: "Compact and central",
    image:
      "https://images.unsplash.com/photo-1555854877-bab0e564b8d5?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "room-5f",
    title: "Backpacker Townhouse",
    area: "University Quarter",
    price: 89,
    rating: 7.9,
    budgetTag: "Budget",
    freeCancel: true,
    breakfast: false,
    tag: "Best for short stays",
    image:
      "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "room-5g",
    title: "Riverside Budget Lodge",
    area: "River Walk",
    price: 94,
    rating: 8.5,
    budgetTag: "Budget",
    freeCancel: true,
    breakfast: true,
    tag: "Great value by the water",
    image:
      "https://images.unsplash.com/photo-1445019980597-93fa8acb246c?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "room-6",
    title: "Old Town Atelier",
    area: "Historic District",
    price: 219,
    rating: 9.0,
    budgetTag: "Mid-range",
    freeCancel: false,
    breakfast: true,
    tag: "Design-forward interiors",
    image:
      "https://images.unsplash.com/photo-1611892440504-42a792e24d32?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "room-7",
    title: "Canal House Retreat",
    area: "Canal District",
    price: 480,
    rating: 9.3,
    budgetTag: "Luxury",
    freeCancel: true,
    breakfast: true,
    tag: "Premium waterfront stay",
    image:
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "room-7b",
    title: "Royal Terrace Suites",
    area: "Embassy Quarter",
    price: 1200,
    rating: 9.4,
    budgetTag: "Luxury",
    freeCancel: true,
    breakfast: true,
    tag: "Refined city luxury",
    image:
      "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "room-7c",
    title: "Skyline Grand Hotel",
    area: "Financial District",
    price: 2500,
    rating: 9.6,
    budgetTag: "Luxury",
    freeCancel: true,
    breakfast: true,
    tag: "Panoramic rooftop views",
    image:
      "https://images.unsplash.com/photo-1445019980597-93fa8acb246c?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "room-7d",
    title: "Opera Palace Rooms",
    area: "Theatre District",
    price: 850,
    rating: 9.1,
    budgetTag: "Luxury",
    freeCancel: false,
    breakfast: true,
    tag: "Elegant classic interiors",
    image:
      "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "room-7e",
    title: "Harbor Crown Suites",
    area: "Marina Front",
    price: 1800,
    rating: 9.2,
    budgetTag: "Luxury",
    freeCancel: true,
    breakfast: false,
    tag: "Marina-view suites",
    image:
      "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "room-7f",
    title: "Signature Residence",
    area: "Designer Mile",
    price: 5000,
    rating: 9.0,
    budgetTag: "Luxury",
    freeCancel: true,
    breakfast: true,
    tag: "Boutique five-star style",
    image:
      "https://images.unsplash.com/photo-1455587734955-081b22074882?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "room-7g",
    title: "Imperial Sky Loft",
    area: "Historic Center",
    price: 10000,
    rating: 9.7,
    budgetTag: "Luxury",
    freeCancel: true,
    breakfast: true,
    tag: "Top-tier penthouse stay",
    image:
      "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "room-8",
    title: "Market Lane Boutique",
    area: "Central Market",
    price: 169,
    rating: 8.8,
    budgetTag: "Mid-range",
    freeCancel: true,
    breakfast: false,
    tag: "Walk-everywhere location",
    image:
      "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=900&q=80",
  },
];

const FALLBACK_ITINERARY = {
  meta: {
    destination: "Selected destination",
    style: "Balanced",
    budget: "Mid-range",
    interests: ["Culture", "Food", "Scenic"],
  },
  days: [
    {
      day: 1,
      theme: "Arrival and neighborhood orientation",
      activities: [
        { time: "09:00", title: "Old Town Walk", location: "City center", description: "Ease into the destination with a guided-style orientation walk." },
        { time: "12:30", title: "Local Market Lunch", location: "Market district", description: "Sample regional dishes and browse artisan stalls." },
        { time: "15:30", title: "Landmark Visit", location: "Historic quarter", description: "Explore the city icon with cultural context and stories." },
        { time: "20:00", title: "Dinner Reservation", location: "Restaurant row", description: "A relaxed first-night dinner matched to your budget." },
      ],
    },
  ],
};

function buildMultiCityDateRanges(stops = [], tripStartDate = "") {
  if (!tripStartDate) return [];
  const start = new Date(`${tripStartDate}T00:00:00`);
  if (!Number.isFinite(start.getTime())) return [];

  let cursor = new Date(start.getTime());
  return stops.map((stop) => {
    const nights = Math.max(1, Number(stop?.nights) || 1);
    const checkInDate = cursor.toISOString().slice(0, 10);
    const next = new Date(cursor.getTime());
    next.setDate(next.getDate() + nights);
    const checkOutDate = next.toISOString().slice(0, 10);
    cursor = next;
    return { checkInDate, checkOutDate };
  });
}

function createEmptyMultiStop() {
  return {
    id: Date.now() + Math.floor(Math.random() * 1000),
    city: "",
    country: "",
    nights: 2,
  };
}

function getTripDaysFromDates(checkInDate, checkOutDate, fallbackDays = 3) {
  if (!checkInDate || !checkOutDate) return fallbackDays;

  const checkIn = new Date(checkInDate);
  const checkOut = new Date(checkOutDate);
  if (!Number.isFinite(checkIn.getTime()) || !Number.isFinite(checkOut.getTime())) return fallbackDays;

  const diffMs = checkOut.getTime() - checkIn.getTime();
  const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
  if (diffDays <= 0) return fallbackDays;
  return diffDays;
}

function getEstimateCost({ budget = "Mid-range", nights = 1, roomPrice = 0 }) {
  const multiplier = budget === "Budget" ? 0.9 : budget === "Luxury" ? 1.65 : 1.15;
  const estimated = Math.max(1, Math.round((Number(roomPrice) || 0) * Math.max(1, nights) * multiplier));
  return `EUR ${estimated}`;
}

function getPreviewTemperature({ city = "", budget = "Mid-range" }) {
  const citySeed = city.length % 7;
  const base = budget === "Budget" ? 17 : budget === "Luxury" ? 24 : 20;
  return `${base + citySeed}°C`;
}

function normalizeBudgetTier(budget = "") {
  const value = String(budget || "").trim().toLowerCase();
  if (value === "budget") return "Budget";
  if (value === "luxury") return "Luxury";
  return "Mid-Range";
}

function getWeatherMood(temperatureText = "") {
  const numeric = Number(String(temperatureText).replace(/[^0-9.-]/g, ""));
  if (!Number.isFinite(numeric)) return "sunny";
  if (numeric >= 28) return "sunny";
  if (numeric >= 22) return "cloudy";
  if (numeric >= 16) return "rain";
  return "storm";
}

function weatherMoodFromCode(code = null) {
  const numeric = Number(code);
  if (!Number.isFinite(numeric)) return "sunny";
  if (numeric === 0 || numeric === 1 || numeric === 2) return "sunny";
  if (numeric === 3 || numeric === 45 || numeric === 48) return "cloudy";
  if ([51, 53, 55, 56, 57, 61, 63, 65, 66, 67, 80, 81, 82].includes(numeric)) return "rain";
  if ([71, 73, 75, 77, 85, 86, 95, 96, 99].includes(numeric)) return "storm";
  return "cloudy";
}

async function fetchLiveWeatherSnapshot({ city = "", country = "" }) {
  const query = [city, country].filter(Boolean).join(", ").trim();
  if (!query) return null;

  const geoUrl = `https://geocoding-api.open-meteo.com/v1/search?name=${encodeURIComponent(query)}&count=1&language=en&format=json`;
  const geoRes = await fetch(geoUrl);
  if (!geoRes.ok) return null;

  const geoData = await geoRes.json();
  const first = Array.isArray(geoData?.results) ? geoData.results[0] : null;
  if (!first || !Number.isFinite(first.latitude) || !Number.isFinite(first.longitude)) return null;

  const weatherUrl = `https://api.open-meteo.com/v1/forecast?latitude=${first.latitude}&longitude=${first.longitude}&current_weather=true&timezone=auto`;
  const weatherRes = await fetch(weatherUrl);
  if (!weatherRes.ok) return null;

  const weatherData = await weatherRes.json();
  const current = weatherData?.current_weather;
  if (!current) return null;

  return {
    temperature: Number.isFinite(current.temperature) ? `${Math.round(current.temperature)}°C` : null,
    mood: weatherMoodFromCode(current.weathercode),
  };
}

const WEATHER_CARD_IMAGES = {
  sunny: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=900&q=80",
  cloudy: "https://images.unsplash.com/photo-1532978379173-523e16f371f1?auto=format&fit=crop&w=900&q=80",
  rain: "https://images.unsplash.com/photo-1515694346937-94d85e41e6f0?auto=format&fit=crop&w=900&q=80",
  storm: "https://images.unsplash.com/photo-1500674425229-f692875b0ab7?auto=format&fit=crop&w=900&q=80",
};

const POLICY_CONTENT = {
  privacy: {
    title: "Privacy Policy",
    content: "AppiHolidays uses local browser storage and AI itinerary processing to keep your travel setup responsive.",
  },
  cookies: {
    title: "Cookies Policy",
    content: "This app uses functional local storage to remember your planner state in the browser.",
  },
  security: {
    title: "Security Policy",
    content: "AppiHolidays prioritizes secure API communication and avoids central storage of your planner data.",
  },
  about: {
    title: "About AppiHolidays",
    content: "AppiHolidays is a travel planning tool for generating smart itineraries and room booking flows.",
  },
};

function resolveDestinationCard({ city = "", country = "" }) {
  const match = SAMPLE_DESTINATIONS.find(
    (item) =>
      item.city.toLowerCase() === String(city || "").trim().toLowerCase() &&
      item.country.toLowerCase() === String(country || "").trim().toLowerCase()
  );

  return match || {
    city,
    country,
    region: "Custom",
    vibe: "Multi-city booking stop",
    image: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=900&q=80",
  };
}

function hashPageFromLocation() {
  if (typeof window === "undefined") return "planner";
  const hash = window.location.hash.replace(/^#/, "");
  return hash && POLICY_CONTENT[hash] ? hash : "planner";
}

function DestinationSelector({ destination, setDestination, searchText, setSearchText, filteredDestinations, selectedRegion, setSelectedRegion, onDestinationSelect, onGoFromSingleCity, onRefreshSingleCity, onRefreshMultiCity, tripCountry, setTripCountry, numDays, setNumDays, singleStartDate, setSingleStartDate, multiStartDate, setMultiStartDate, checkInDate, checkOutDate, setCheckOutDate, budgetFilter, setBudgetFilter, multiStops, multiStopDateRanges, onAddMultiStop, onRemoveMultiStop, onUpdateMultiStop, onGoToRooms }) {
  const groupedDestinations = REGION_ORDER
    .map((region) => ({
      region,
      items: filteredDestinations.filter((item) => item.region === region),
    }))
    .filter((group) => group.items.length > 0);

  return (
    <>
      <section className="v2-panel">
        <h2>Choose destination</h2>
        <p>Single city search and setup.</p>
        <div className="v2-trip-setup">
        <div className="v2-filter-budget-row" aria-label="Room budget filters">
          {[
            { value: "Any", label: "All" },
            { value: "Budget", label: "Budget" },
            { value: "Mid-range", label: "Mid-Range" },
            { value: "Luxury", label: "Luxury" },
          ].map((option) => (
            <button
              key={option.value}
              type="button"
              className={budgetFilter === option.value ? "v2-budget-pill active" : "v2-budget-pill"}
              onClick={() => setBudgetFilter(option.value)}
            >
              {option.label}
            </button>
          ))}
        </div>
        <div className="v2-trip-setup-row">
          <label className="v2-filter-control">
            <span>Number of days</span>
            <input
              type="number"
              min="1"
              max="365"
              value={numDays}
              onChange={(event) => setNumDays(event.target.value)}
              placeholder="e.g. 7"
            />
          </label>
          <label className="v2-filter-control">
            <span>Trip start / Check-in</span>
            <input
              type="date"
              value={singleStartDate}
              onChange={(event) => setSingleStartDate(event.target.value)}
            />
          </label>
          <label className="v2-filter-control">
            <span>Check-out <span className="v2-auto-tag">auto</span></span>
            <input
              type="date"
              value={checkOutDate}
              min={checkInDate || undefined}
              onChange={(event) => setCheckOutDate(event.target.value)}
            />
          </label>
        </div>
        <div className="v2-trip-setup-row">
          <label className="v2-filter-control">
            <span>Search city</span>
            <input
              type="text"
              value={searchText}
              onChange={(event) => setSearchText(event.target.value)}
              placeholder="City or country"
            />
          </label>
          <label className="v2-filter-control">
            <span>Country</span>
            <input
              type="text"
              value={tripCountry}
              onChange={(event) => setTripCountry(event.target.value)}
              placeholder="e.g. Portugal"
            />
          </label>
          <label className="v2-filter-control">
            <span>Region</span>
            <select value={selectedRegion} onChange={(event) => setSelectedRegion(event.target.value)}>
              <option value="Any">Any region</option>
              {REGION_ORDER.map((region) => (
                <option key={region} value={region}>{region}</option>
              ))}
            </select>
          </label>
        </div>
        <div className="v2-go-single-wrap">
          <button type="button" className="v2-go-rooms-btn" onClick={onGoFromSingleCity}>
            Go
          </button>
          <button type="button" className="v2-refresh-btn" onClick={onRefreshSingleCity}>
            Refresh
          </button>
        </div>
        </div>
      </section>

      <section className="v2-panel">
        <h2>Multi-city search</h2>
        <p>Add multiple city stops and dates, then view rooms by city.</p>
        <div className="v2-multi-city-tools">
          <div className="v2-multi-city-head">
            <strong>Multi-city stops</strong>
            <span>City, country, and nights per stop</span>
          </div>
          <div className="v2-multi-stop-actions">
            <label className="v2-multi-start-date">
              <span>Start date</span>
              <input
                type="date"
                value={multiStartDate}
                onChange={(event) => setMultiStartDate(event.target.value)}
              />
            </label>
          </div>
          {multiStops.length > 0 ? (
            <div className="v2-multi-stop-list" aria-label="Multi-city stops">
              {multiStops.map((stop, index) => (
                <div key={stop.id} className="v2-multi-stop-row">
                  <div className="v2-multi-stop-index">{index + 1}</div>
                  <input
                    type="text"
                    placeholder="City"
                    value={stop.city}
                    onChange={(event) => onUpdateMultiStop(stop.id, "city", event.target.value)}
                  />
                  <input
                    type="text"
                    placeholder="Country"
                    value={stop.country}
                    onChange={(event) => onUpdateMultiStop(stop.id, "country", event.target.value)}
                  />
                  <input
                    type="number"
                    min="1"
                    max="14"
                    placeholder="Days"
                    value={stop.nights}
                    onChange={(event) => onUpdateMultiStop(stop.id, "nights", Math.max(1, Number(event.target.value) || 1))}
                  />
                  <div className="v2-multi-stop-dates">
                    <span>{multiStopDateRanges[index]?.checkInDate || "--"}</span>
                    <span>{multiStopDateRanges[index]?.checkOutDate || "--"}</span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="v2-multi-city-hint">No city stops yet. Add one to plan across countries.</p>
          )}
          <div className="v2-multi-add-wrap">
            <button type="button" className="v2-add-city-btn" onClick={onAddMultiStop}>
              + Add another city
            </button>
          </div>
          <div className="v2-go-rooms-wrap">
            <button type="button" className="v2-go-rooms-btn" onClick={onGoToRooms}>
              Go
            </button>
            <button type="button" className="v2-refresh-btn" onClick={onRefreshMultiCity}>
              Refresh
            </button>
          </div>
        </div>
      </section>

      <section className="v2-panel">
        <h2>Popular Destinations</h2>
        <p>Global Destinations</p>
        {groupedDestinations.length === 0 ? (
          <div className="v2-empty-state">No destinations match your search or region filter.</div>
        ) : (
          groupedDestinations.map((group) => (
            <div className="v2-group-block" key={group.region}>
              <h3 className="v2-group-title">{group.region}</h3>
              <div className="v2-grid">
                {group.items.map((item) => {
                  const active = destination.city === item.city;
                  return (
                    <button
                      key={item.city}
                      type="button"
                      className={active ? "v2-pill active" : "v2-pill"}
                      onClick={() => {
                        setDestination(item);
                        setTripCountry(item.country);
                        onDestinationSelect?.("destination");
                      }}
                    >
                      <div
                        className="v2-pill-bg"
                        style={{
                          backgroundImage: `linear-gradient(165deg, rgba(0, 0, 0, 0.24) 0%, rgba(0, 0, 0, 0.62) 100%), url(${item.image})`,
                        }}
                      />
                      <div className="v2-pill-content">
                        <span>{item.city}, {item.country}</span>
                        <small>{item.vibe}</small>
                      </div>
                    </button>
                  );
                })}
              </div>
            </div>
          ))
        )}
      </section>
    </>
  );
}

function RoomCard({ room, selected, onSelect, destinationLabel = "" }) {
  return (
    <article className={selected ? "v2-room selected" : "v2-room"}>
      <img src={room.image} alt={room.title} loading="lazy" />
      <div className="v2-room-body">
        {destinationLabel ? <div className="v2-room-destination">{destinationLabel}</div> : null}
        <div className="v2-room-top">
          <h3>{room.title}</h3>
          <strong>EUR {room.price}/night</strong>
        </div>
        <p>{room.area}</p>
        <div className="v2-room-meta">
          <span>{room.tag}</span>
          <span>{room.rating}/10</span>
        </div>
        <div className="v2-room-meta v2-room-meta-small">
          <span>{room.budgetTag}</span>
          <span>{room.breakfast ? "Breakfast" : "No breakfast"}</span>
          <span>{room.freeCancel ? "Free cancel" : "Non-refundable"}</span>
        </div>
        <button type="button" onClick={() => onSelect(room)}>
          {selected ? "Selected" : "Select room"}
        </button>
      </div>
    </article>
  );
}

function RoomsSkeleton() {
  return (
    <div className="v2-room-list">
      {Array.from({ length: 3 }).map((_, index) => (
        <article className="v2-room v2-room-skeleton" key={`s-${index}`}>
          <div className="v2-skel-img" />
          <div className="v2-room-body">
            <div className="v2-skel-line" />
            <div className="v2-skel-line short" />
            <div className="v2-skel-line" />
            <div className="v2-skel-button" />
          </div>
        </article>
      ))}
    </div>
  );
}

function ItineraryPreview({ itinerary, loading, error, mode, liveWeather, selectedRoom, tripDays, destination, bookedCityItineraries = [] }) {
  if (loading) {
    return (
      <section className="v2-panel">
        <h2>Itinerary preview</h2>
        <p>Preparing your plan in {mode} mode...</p>
        <div className="v2-skel-line" />
        <div className="v2-skel-line" />
        <div className="v2-skel-line short" />
      </section>
    );
  }

  if (error) {
    return (
      <section className="v2-panel v2-error">
        <h2>Itinerary preview</h2>
        <p>{error}</p>
      </section>
    );
  }

  if (bookedCityItineraries.length > 0) {
    return (
      <section className="v2-panel">
        <h2>Multi-city itinerary</h2>
        <p>{bookedCityItineraries.length} city plans generated from your selected rooms.</p>
        <div className="v2-multi-itinerary-list">
          {bookedCityItineraries.map((entry, cityIndex) => (
            <article key={entry.stopId || `${entry.city}-${cityIndex}`} className="v2-multi-itinerary-item">
              <h3>
                {cityIndex + 1}. {entry.city}, {entry.country}
              </h3>
              <p>
                Stay: {entry.checkInDate || "N/A"} to {entry.checkOutDate || "N/A"} | Room: {entry.roomTitle || "Selected room"}
              </p>
              <div className="v2-preview-list">
                {(entry.itinerary?.days || []).slice(0, 2).map((day) => (
                  <div key={`${entry.stopId}-day-${day.day}`} className="v2-multi-itinerary-day">
                    <h4>Day {day.day}: {day.theme}</h4>
                    {(day.activities || []).slice(0, 3).map((item, index) => (
                      <div key={`${entry.stopId}-${day.day}-${index}`} className="v2-preview-item">
                        <strong>{item.time}</strong>
                        <span>{item.title} - {item.location}</span>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </article>
          ))}
        </div>
      </section>
    );
  }

  const dayOne = itinerary?.days?.[0];
  const destinationCity = itinerary?.meta?.destination || "Destination pending";
  const budgetTier = normalizeBudgetTier(itinerary?.meta?.budget || selectedRoom?.budgetTag || "Mid-range");
  const temperature = liveWeather?.temperature || getPreviewTemperature({
    city: destinationCity,
    budget: itinerary?.meta?.budget || "Mid-range",
  });
  const weatherMood = liveWeather?.mood || getWeatherMood(temperature);
  const roomCost = getEstimateCost({
    budget: itinerary?.meta?.budget || "Mid-range",
    nights: Math.max(1, tripDays || (dayOne?.activities?.length ? Math.max(1, dayOne.activities.length - 1) : 1)),
    roomPrice: Number(selectedRoom?.price) || 180,
  });
  return (
    <section className="v2-panel">
      <h2>Itinerary preview</h2>
      <p>{destinationCity}</p>
      <div className="v2-preview-cards">
        <div
          className="v2-preview-card v2-preview-card-temp"
          style={{ backgroundImage: `url(${WEATHER_CARD_IMAGES[weatherMood]})` }}
        >
          <span>Temperature</span>
          <strong>{temperature}</strong>
        </div>
        <div
          className="v2-preview-card v2-preview-card-city"
          style={{ backgroundImage: `url(${destination?.image || "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?auto=format&fit=crop&w=900&q=80"})` }}
        >
          <span>City</span>
          <strong>{destinationCity}</strong>
        </div>
        <div
          className="v2-preview-card v2-preview-card-cost"
          style={{ backgroundImage: "url(https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=900&q=80)" }}
        >
          <span>Est Cost</span>
          <strong>{roomCost}</strong>
        </div>
        <div
          className="v2-preview-card v2-preview-card-budget"
          style={{ backgroundImage: "url(https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=900&q=80)" }}
        >
          <span>Budget</span>
          <strong>{budgetTier}</strong>
          <div className="v2-budget-pills" aria-label="Budget tier options">
            {[
              { label: "Budget", active: budgetTier === "Budget" },
              { label: "Mid-Range", active: budgetTier === "Mid-Range" },
              { label: "Luxury", active: budgetTier === "Luxury" },
            ].map((tier) => (
              <div key={tier.label} className={tier.active ? "v2-budget-pill active" : "v2-budget-pill"}>
                {tier.label}
              </div>
            ))}
          </div>
        </div>
      </div>
      {dayOne ? (
        <div className="v2-preview-list">
          <h3>Day {dayOne.day}: {dayOne.theme}</h3>
          {(dayOne.activities || []).slice(0, 3).map((item, index) => (
            <div key={`${item.title}-${index}`} className="v2-preview-item">
              <strong>{item.time}</strong>
              <span>{item.title} - {item.location}</span>
            </div>
          ))}
        </div>
      ) : (
        <p>Your itinerary preview will appear here.</p>
      )}
    </section>
  );
}

function FullItineraryView({ itinerary, bookedCityItineraries = [], destination, liveWeather }) {
  const cityPlans = bookedCityItineraries.length > 0
    ? bookedCityItineraries.map((entry) => ({
      city: entry.city,
      country: entry.country,
      checkInDate: entry.checkInDate,
      checkOutDate: entry.checkOutDate,
      roomTitle: entry.roomTitle,
      itinerary: entry.itinerary,
    }))
    : [{
      city: destination?.city || "Destination",
      country: destination?.country || "",
      checkInDate: "",
      checkOutDate: "",
      roomTitle: "Selected room",
      itinerary,
    }];

  return (
    <section className="v2-panel v2-full-itinerary">
      <h2>Full itinerary</h2>
      <p>Styled full itinerary view based on your selected city rooms.</p>

      <div className="v2-full-list">
        {cityPlans.map((plan, cityIndex) => {
          const getFallbackNearbyEats = (city) => ({
            breakfast: [
              { name: `Corner Espresso ${city}`, cuisine: "Coffee & Pastries", price: "$", distance: "5-10 min walk", mapLink: "" },
              { name: `Pane & Caffe ${city}`, cuisine: "Bakery & Coffee", price: "$", distance: "8-15 min walk", mapLink: "" },
            ],
            lunch: [
              { name: `Neighborhood Pasta Bar ${city}`, cuisine: "Local", price: "$", distance: "5-10 min walk", mapLink: "" },
              { name: `Street Plate ${city}`, cuisine: "Street Food", price: "$", distance: "8-15 min walk", mapLink: "" },
            ],
            dinner: [
              { name: `Family Trattoria ${city}`, cuisine: "Traditional", price: "$", distance: "5-10 min walk", mapLink: "" },
              { name: `Osteria Semplice ${city}`, cuisine: "Regional", price: "$", distance: "8-15 min walk", mapLink: "" },
            ],
          });

          const normalizeNearbyEats = (activity, city) => {
            const src = activity?.nearbyEats || activity?.nearby || activity?.eats;
            const fallback = getFallbackNearbyEats(city);
            if (!src || typeof src !== "object") return fallback;

            const toItems = (value, fallbackItems) => {
              if (!Array.isArray(value) || value.length === 0) return fallbackItems;
              return value
                .map((item) => {
                  if (typeof item === "string") {
                    return { name: item, cuisine: "Local", price: "$", distance: "5-10 min walk", mapLink: "" };
                  }
                  if (!item || typeof item !== "object") return null;
                  return {
                    name: item.name || "Restaurant",
                    cuisine: item.cuisine || "Local",
                    price: item.price || "$",
                    distance: item.distance || "5-10 min walk",
                    mapLink: item.mapLink || "",
                  };
                })
                .filter(Boolean)
                .slice(0, 2);
            };

            return {
              breakfast: toItems(src.breakfast, fallback.breakfast),
              lunch: toItems(src.lunch, fallback.lunch),
              dinner: toItems(src.dinner, fallback.dinner),
            };
          };

          const resolveWeather = (day) => {
            const baseCondition = day?.weather?.condition || day?.weather?.summary || (liveWeather?.mood === "rain" ? "Rain" : liveWeather?.mood === "cloudy" ? "Cloudy" : "Partly cloudy");
            const icon = String(baseCondition).toLowerCase().includes("rain") ? "🌧️" : String(baseCondition).toLowerCase().includes("cloud") ? "☁️" : "⛅";
            return {
              icon,
              condition: baseCondition,
              advice: "Plan flexibly and check live updates",
              high: day?.weather?.high || liveWeather?.temperature || "N/A",
              low: day?.weather?.low || "N/A",
              humidity: day?.weather?.humidity || "N/A",
              wind: day?.weather?.wind || "N/A",
            };
          };

          const days = Array.isArray(plan.itinerary?.days) ? plan.itinerary.days : [];
          const topHighlights = days.flatMap((day) => (day?.activities || []).slice(0, 2)).slice(0, 3);
          return (
            <article key={`${plan.city}-${cityIndex}`} className="v2-full-city-block">
              <h3>{cityIndex + 1}. {plan.city}{plan.country ? `, ${plan.country}` : ""}</h3>
              <p>Stay: {plan.checkInDate || "N/A"} to {plan.checkOutDate || "N/A"} | Room: {plan.roomTitle || "Selected room"}</p>

              <div className="v2-full-transport">
                <div className="v2-full-transport-title">✈️ {plan.city} Airport → City Center</div>
                <ul>
                  <li>🚌 Airport coach: 30-50 min, typical one-way city transfer.</li>
                  <li>🚕 Taxi: 25-45 min, fare varies by traffic and time.</li>
                  <li>ℹ️ Use official airport transport desks for latest local rates.</li>
                </ul>
              </div>

              {topHighlights.length > 0 ? (
                <div className="v2-full-highlights">
                  <div className="v2-full-highlights-title">🌟 Top Highlights</div>
                  <ul>
                    {topHighlights.map((item, index) => (
                      <li key={`${plan.city}-highlight-${index}`}>{item.title || item.location || "Local highlight"}</li>
                    ))}
                  </ul>
                </div>
              ) : null}

              <div className="v2-full-days">
                {days.map((day, dayIndex) => {
                  const weather = resolveWeather(day);
                  return (
                    <div key={`${plan.city}-day-${day.day || dayIndex + 1}`} className="v2-full-day-card">
                      <div className="v2-full-day-head">
                        <h4>{day.day || dayIndex + 1} {day.theme || day.title || "Day Plan"}</h4>
                      </div>

                      <div className="v2-full-weather-panel">
                        <div className="v2-full-weather-main">
                          <span className="v2-full-weather-icon">{weather.icon}</span>
                          <div>
                            <div className="v2-full-weather-condition">{weather.condition}</div>
                            <div className="v2-full-weather-advice">{weather.advice}</div>
                          </div>
                        </div>
                        <div className="v2-full-weather-temp">{weather.high}</div>
                        <div className="v2-full-weather-low">Low: {weather.low}</div>
                        <div className="v2-full-weather-meta">
                          <span>💧 {weather.humidity}</span>
                          <span>🌬️ {weather.wind}</span>
                        </div>
                      </div>

                      {(day.activities || []).map((activity, activityIndex) => {
                        const nearbyEats = normalizeNearbyEats(activity, plan.city || "City");
                        const categoryText = activity.category || "activity";
                        const categoryIcon = categoryText.toLowerCase().includes("dining") ? "🍽️" : "📍";
                        const costText = activity.cost || "N/A";
                        const durationText = activity.duration || "N/A";
                        const locationText = activity.location || "N/A";
                        const specialtiesText = activity.specialties || "N/A";
                        const tipText = activity.tip || "N/A";
                        const themeText = activity.theme || "N/A";
                        const mapLink = String(activity.mapLink || "").trim();
                        return (
                          <div key={`${plan.city}-activity-${activityIndex}`} className="v2-full-activity">
                            <div className="v2-full-activity-title">{activity.time || "--:--"} | {activity.title || "Activity"}</div>
                            <div className="v2-full-activity-kv"><span>{categoryIcon}</span><span>{categoryText}</span></div>
                            <div className="v2-full-activity-kv"><span>💵</span><span>{costText}</span></div>
                            <div className="v2-full-activity-kv"><span>⏱️</span><span>{durationText}</span></div>
                            {activity.description ? <p>{activity.description}</p> : null}
                            {activity.culturalStory ? <p className="v2-full-activity-story">{activity.culturalStory}</p> : null}
                            <p className="v2-full-activity-tip"><strong>Location:</strong> {locationText}</p>
                            <p className="v2-full-activity-tip"><strong>Specialties:</strong> {specialtiesText}</p>
                            <p className="v2-full-activity-tip"><strong>Tip:</strong> {tipText}</p>
                            <p className="v2-full-activity-tip"><strong>🎯 Theme:</strong> {themeText}</p>

                            <div className="v2-full-nearby-eats">
                              <div className="v2-full-nearby-title">Nearby Eats</div>
                              {[
                                { key: "breakfast", label: "🥐 Breakfast", items: nearbyEats.breakfast },
                                { key: "lunch", label: "🥗 Lunch", items: nearbyEats.lunch },
                                { key: "dinner", label: "🍝 Dinner", items: nearbyEats.dinner },
                              ].map((meal) => (
                                <div key={`${plan.city}-${activityIndex}-${meal.key}`} className="v2-full-nearby-meal">
                                  <div className="v2-full-nearby-meal-title">{meal.label}</div>
                                  {meal.items.map((place, placeIndex) => (
                                    <div key={`${plan.city}-${activityIndex}-${meal.key}-${placeIndex}`} className="v2-full-nearby-item">
                                        {place.mapLink ? (
                                          <a href={place.mapLink} target="_blank" rel="noopener noreferrer">{place.name} ↗</a>
                                        ) : (
                                          <span>{place.name}</span>
                                        )}
                                      <span>• {place.cuisine}</span>
                                      <span>• {place.price}</span>
                                      <span>• {place.distance}</span>
                                    </div>
                                  ))}
                                </div>
                              ))}
                              {mapLink ? (
                                <a href={mapLink} target="_blank" rel="noopener noreferrer" className="v2-full-map-link">Map ↗</a>
                              ) : (
                                <button type="button" className="v2-full-map-link">Map ↗</button>
                              )}
                            </div>
                          </div>
                        );
                      })}

                      {day.transportTips ? <div className="v2-full-transport-note">ℹ️ {day.transportTips}</div> : null}
                    </div>
                  );
                })}
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}

function PinchyInventoryPanel({ open, onClose, destination, selectedRoom, budget, days, checkInDate, checkOutDate, mode, selectedRoomEntries = [], onSelectRoom, onStartPayment }) {
  if (!open) return null;

  const fallbackItems = [
    selectedRoom,
    ROOM_LIBRARY.find((room) => room.id !== selectedRoom?.id && room.budgetTag === budget),
    ROOM_LIBRARY.find((room) => room.id !== selectedRoom?.id && room.price <= 180),
  ].filter(Boolean).slice(0, 3);
  const inventoryItems = selectedRoomEntries.length > 0 ? selectedRoomEntries : fallbackItems;

  return (
    <div className="v2-pinchy-overlay" role="dialog" aria-modal="true" aria-label="Pinchy room inventory">
      <div className="v2-pinchy-shell">
        <div className="v2-pinchy-hero">
          <div className="v2-pinchy-hero-inner">
            <img src={logo} alt="AppiHolidays logo" className="v2-pinchy-logo" />
            <div>
              <span className="v2-kicker">AppiHolidays • Pinchy inventory</span>
              <h2>Room inventory for {destination.city}</h2>
              <p>
                You’re still inside AppiHolidays. This space is the room inventory handoff area for Pinchy.ai,
                ready for later integration.
              </p>
            </div>
          </div>
          <button type="button" className="v2-pinchy-close" onClick={onClose}>Close</button>
        </div>

        <div className="v2-pinchy-meta">
          <div><span>Destination</span><strong>{destination.city}, {destination.country}</strong></div>
          <div><span>Budget</span><strong>{budget}</strong></div>
          <div><span>Stay</span><strong>{checkInDate || "Select dates"} - {checkOutDate || "Select dates"}</strong></div>
          <div><span>Days</span><strong>{days || "-"}</strong></div>
          <div><span>Mode</span><strong>{mode === "live" ? "Live" : "Demo"}</strong></div>
        </div>

        <div className="v2-pinchy-grid">
          {inventoryItems.map((room) => (
            <article
              key={room.id}
              className={room.id === selectedRoom?.id ? "v2-pinchy-room active" : "v2-pinchy-room"}
            >
              <img src={room.image} alt={room.title} />
              <div className="v2-pinchy-room-body">
                <div className="v2-pinchy-room-top">
                  <h3>{room.title}</h3>
                  <strong>EUR {room.price}/night</strong>
                </div>
                <p>{room.area}</p>
                {room.selectionLabel ? <p>{room.selectionLabel}</p> : null}
                <div className="v2-pinchy-room-meta">
                  <span>{room.budgetTag}</span>
                  <span>{room.rating}/10</span>
                </div>
                <button
                  type="button"
                  className="v2-pinchy-select-btn"
                  onClick={() => onSelectRoom?.(room.id)}
                >
                  {room.id === selectedRoom?.id ? "Selected" : "Select room"}
                </button>
              </div>
            </article>
          ))}
        </div>

        <div className="v2-pinchy-actions">
          <button
            type="button"
            className="v2-pinchy-pay-btn"
            disabled={!selectedRoom || !checkInDate || !checkOutDate}
            onClick={() => onStartPayment?.()}
          >
            Start payment
          </button>
        </div>
      </div>
    </div>
  );
}

export default function AppV2({ mode = "live" }) {
  const [destination, setDestination] = useState(SAMPLE_DESTINATIONS[0]);
  const [searchText, setSearchText] = useState("");
  const [selectedRegion, setSelectedRegion] = useState("Any");
  const [budgetFilter, setBudgetFilter] = useState("Any");
  const [sortBy] = useState("recommended");
  const [maxNightlyPrice] = useState(10000);
  const [selectedRoomId, setSelectedRoomId] = useState(null);
  const [checkInDate, setCheckInDate] = useState("");
  const [checkOutDate, setCheckOutDate] = useState("");
  const [loadingRooms, setLoadingRooms] = useState(false);
  const [itineraryLoading, setItineraryLoading] = useState(false);
  const [itineraryError, setItineraryError] = useState("");
  const [itinerary, setItinerary] = useState(FALLBACK_ITINERARY);
  const [roomsOpen, setRoomsOpen] = useState(true);
  const [roomsFlash, setRoomsFlash] = useState(false);
  const [liveWeather, setLiveWeather] = useState(null);
  const [pinchyInventoryOpen, setPinchyInventoryOpen] = useState(false);
  const [tripCountry, setTripCountry] = useState("");
  const [numDays, setNumDays] = useState("");
  const [singleStartDate, setSingleStartDate] = useState("");
  const [multiStartDate, setMultiStartDate] = useState("");
  const [multiStops, setMultiStops] = useState(() => [createEmptyMultiStop()]);
  const [multiCityRoomSelections, setMultiCityRoomSelections] = useState({});
  const [activeStopIndex, setActiveStopIndex] = useState(0);
  const [bookedCityItineraries, setBookedCityItineraries] = useState([]);
  const [roomSelectionNotice, setRoomSelectionNotice] = useState("");
  const [showFullItinerary, setShowFullItinerary] = useState(false);
  const [currentPage, setCurrentPage] = useState(() => hashPageFromLocation());
  const [showMultiCityRooms, setShowMultiCityRooms] = useState(false);
  const [singleCityRoomScope, setSingleCityRoomScope] = useState("global");
  const roomsSectionRef = React.useRef(null);
  const itinerarySectionRef = React.useRef(null);
  const fullItinerarySectionRef = React.useRef(null);

  const multiStopDateRanges = useMemo(
    () => buildMultiCityDateRanges(multiStops, multiStartDate),
    [multiStops, multiStartDate]
  );

  const normalizedMultiStops = useMemo(
    () => multiStops
      .map((stop, index) => ({
        ...stop,
        checkInDate: multiStopDateRanges[index]?.checkInDate || "",
        checkOutDate: multiStopDateRanges[index]?.checkOutDate || "",
      }))
      .filter((stop) => String(stop.city || "").trim() && String(stop.country || "").trim()),
    [multiStops, multiStopDateRanges]
  );

  const bookingFlowStops = useMemo(() => {
    const primaryStop = {
      id: "primary-stop",
      city: destination.city,
      country: destination.country,
      region: destination.region,
      nights: Math.max(1, getTripDaysFromDates(checkInDate, checkOutDate, Number(numDays) || 1)),
      checkInDate,
      checkOutDate,
    };

    const extras = normalizedMultiStops.filter(
      (stop) =>
        stop.city.toLowerCase() !== String(primaryStop.city || "").toLowerCase() ||
        stop.country.toLowerCase() !== String(primaryStop.country || "").toLowerCase()
    );

    return [primaryStop, ...extras];
  }, [destination.city, destination.country, destination.region, numDays, checkInDate, checkOutDate, normalizedMultiStops]);

  const roomCitiesForDisplay = useMemo(() => {
    const seen = new Set();
    const rows = [];
    bookingFlowStops.forEach((stop) => {
      const key = `${String(stop.city || "").toLowerCase()}|${String(stop.country || "").toLowerCase()}`;
      if (!stop.city || !stop.country || seen.has(key)) return;
      seen.add(key);
      rows.push(stop);
    });
    return rows;
  }, [bookingFlowStops]);

  const resolveStopDates = React.useCallback((stop) => {
    const matchedMultiStop = normalizedMultiStops.find(
      (item) =>
        item.city.toLowerCase() === String(stop?.city || "").toLowerCase() &&
        item.country.toLowerCase() === String(stop?.country || "").toLowerCase()
    );
    return {
      checkInDate: stop?.checkInDate || matchedMultiStop?.checkInDate || "",
      checkOutDate: stop?.checkOutDate || matchedMultiStop?.checkOutDate || "",
    };
  }, [normalizedMultiStops]);

  const allMultiCityRoomsSelected = useMemo(() => {
    if (!showMultiCityRooms || roomCitiesForDisplay.length === 0) return false;
    return roomCitiesForDisplay.every((stop) => Boolean(multiCityRoomSelections[stop.id]));
  }, [showMultiCityRooms, roomCitiesForDisplay, multiCityRoomSelections]);

  const multiCitySelectedCount = useMemo(
    () => roomCitiesForDisplay.filter((stop) => Boolean(multiCityRoomSelections[stop.id])).length,
    [roomCitiesForDisplay, multiCityRoomSelections]
  );

  const multiCitySelectedRoomEntries = useMemo(
    () => roomCitiesForDisplay
      .map((stop) => {
        const roomId = multiCityRoomSelections[stop.id];
        const room = ROOM_LIBRARY.find((item) => item.id === roomId);
        if (!room) return null;
        return {
          ...room,
          selectionLabel: `${stop.city}, ${stop.country}`,
        };
      })
      .filter(Boolean),
    [roomCitiesForDisplay, multiCityRoomSelections]
  );

  const filteredDestinations = useMemo(() => {
    const q = searchText.trim().toLowerCase();
    const c = tripCountry.trim().toLowerCase();
    return SAMPLE_DESTINATIONS.filter((item) => {
      const matchesText = !q || `${item.city} ${item.country}`.toLowerCase().includes(q);
      const matchesRegion = selectedRegion === "Any" || item.region === selectedRegion;
      const matchesCountry = !c || item.country.toLowerCase().includes(c);
      return matchesText && matchesRegion && matchesCountry;
    });
  }, [searchText, selectedRegion, tripCountry]);

  const filteredRooms = useMemo(() => {
    let rooms = ROOM_LIBRARY.filter((room) => room.price <= maxNightlyPrice);
    if (budgetFilter !== "Any") {
      rooms = rooms.filter((room) => room.budgetTag === budgetFilter);
    }

    const sorted = [...rooms];
    if (sortBy === "priceAsc") sorted.sort((a, b) => a.price - b.price);
    if (sortBy === "priceDesc") sorted.sort((a, b) => b.price - a.price);
    if (sortBy === "ratingDesc") sorted.sort((a, b) => b.rating - a.rating);
    return sorted;
  }, [budgetFilter, maxNightlyPrice, sortBy]);

  const selectedRoom = useMemo(
    () => filteredRooms.find((room) => room.id === selectedRoomId) || ROOM_LIBRARY.find((room) => room.id === selectedRoomId) || null,
    [filteredRooms, selectedRoomId]
  );

  const hasValidStayDates = useMemo(() => {
    if (!checkInDate || !checkOutDate) return false;
    const checkIn = new Date(checkInDate);
    const checkOut = new Date(checkOutDate);
    return Number.isFinite(checkIn.getTime()) && Number.isFinite(checkOut.getTime()) && checkOut > checkIn;
  }, [checkInDate, checkOutDate]);

  const tripDays = useMemo(
    () => getTripDaysFromDates(checkInDate, checkOutDate, 3),
    [checkInDate, checkOutDate]
  );

  useEffect(() => {
    setLoadingRooms(true);
    const timeout = setTimeout(() => setLoadingRooms(false), 800);
    return () => clearTimeout(timeout);
  }, [destination, budgetFilter, sortBy, maxNightlyPrice]);

  useEffect(() => {
    if (!selectedRoomId || !filteredRooms.length) return;
    const hasCurrent = filteredRooms.some((room) => room.id === selectedRoomId);
    if (!hasCurrent) setSelectedRoomId(filteredRooms[0].id);
  }, [filteredRooms, selectedRoomId]);

  useEffect(() => {
    if (activeStopIndex < bookingFlowStops.length) return;
    setActiveStopIndex(Math.max(0, bookingFlowStops.length - 1));
  }, [activeStopIndex, bookingFlowStops.length]);

  useEffect(() => {
    if (activeStopIndex > 0) return;
    if (!singleStartDate) {
      setCheckInDate("");
      return;
    }
    setCheckInDate(singleStartDate);
    if (numDays && Number(numDays) >= 1) {
      const start = new Date(singleStartDate);
      start.setDate(start.getDate() + Number(numDays));
      setCheckOutDate(start.toISOString().split("T")[0]);
    }
  }, [singleStartDate, numDays, activeStopIndex]);

  useEffect(() => {
    if (checkInDate && checkOutDate) {
      setRoomSelectionNotice("");
    }
  }, [checkInDate, checkOutDate]);

  const handleDestinationSelect = (scope = "global") => {
    setSingleCityRoomScope(scope);
    setRoomsOpen(true);
    setRoomsFlash(true);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (roomsSectionRef.current && typeof roomsSectionRef.current.scrollIntoView === "function") {
          roomsSectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    });
    setTimeout(() => setRoomsFlash(false), 900);
  };

  const handleRoomSelect = (room) => {
    if (!room || !room.id) return;
    if (!showMultiCityRooms && (!checkInDate || !checkOutDate)) {
      setRoomSelectionNotice("Please select check-in and check-out dates first.");
      return;
    }
    setRoomSelectionNotice("");
    setSelectedRoomId(room.id);
    setPinchyInventoryOpen(true);
  };

  const handleSeeMoreRooms = () => {
    const roomForHandoff = selectedRoom || filteredRooms[0] || ROOM_LIBRARY[0];
    if (!roomForHandoff) return;
    setPinchyInventoryOpen(true);
  };

  const toTitle = (value = "") =>
    String(value)
      .trim()
      .replace(/\s+/g, " ")
      .split(" ")
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
      .join(" ");

  const handleGoFromSingleCity = () => {
    const rawCity = String(searchText || "").trim();
    const rawCountry = String(tripCountry || "").trim();

    if (!rawCity && !rawCountry) {
      handleDestinationSelect("global");
      return;
    }

    const exactMatch = SAMPLE_DESTINATIONS.find(
      (item) =>
        item.city.toLowerCase() === rawCity.toLowerCase() &&
        (!rawCountry || item.country.toLowerCase() === rawCountry.toLowerCase()) &&
        (selectedRegion === "Any" || item.region === selectedRegion)
    );

    if (exactMatch) {
      setDestination(exactMatch);
      setTripCountry(exactMatch.country);
      handleDestinationSelect("destination");
      return;
    }

    const customDestination = {
      city: toTitle(rawCity || destination.city),
      country: toTitle(rawCountry || destination.country),
      region: selectedRegion === "Any" ? "Custom" : selectedRegion,
      vibe: "Custom destination search",
      image: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=900&q=80",
    };

    setDestination(customDestination);
    handleDestinationSelect("destination");
  };

  const handleGoToRooms = () => {
    setRoomSelectionNotice("");
    setShowMultiCityRooms(true);
    setPinchyInventoryOpen(false);
    setRoomsOpen(true);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        roomsSectionRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  };

  const buildV1HandoffPayload = () => {
    const activeBudget = budgetFilter === "Any" ? "Mid-range" : budgetFilter;

    if (showMultiCityRooms && roomCitiesForDisplay.length > 0) {
      const cities = roomCitiesForDisplay.map((stop) => {
        const roomId = multiCityRoomSelections[stop.id];
        const room = ROOM_LIBRARY.find((item) => item.id === roomId) || null;
        const { checkInDate: stopCheckInDate, checkOutDate: stopCheckOutDate } = resolveStopDates(stop);
        return {
          city: stop.city,
          country: stop.country,
          nights: stop.nights,
          checkInDate: stopCheckInDate,
          checkOutDate: stopCheckOutDate,
          roomId: room?.id || "",
          roomTitle: room?.title || "",
        };
      });

      return {
        source: "v2",
        flow: "multi",
        budget: activeBudget,
        generatedAt: new Date().toISOString(),
        cities,
      };
    }

    return {
      source: "v2",
      flow: "single",
      budget: activeBudget,
      generatedAt: new Date().toISOString(),
      cities: [{
        city: destination.city,
        country: destination.country,
        nights: tripDays,
        checkInDate,
        checkOutDate,
        roomId: selectedRoom?.id || "",
        roomTitle: selectedRoom?.title || "",
      }],
    };
  };

  const handoffToV1Generator = () => {
    const payload = buildV1HandoffPayload();
    try {
      window.localStorage.setItem("appi.v2.handoff.v1", JSON.stringify(payload));
    } catch {}
    window.location.href = "/v1?handoff=v2";
  };

  const handleContinueToItinerary = () => {
    handoffToV1Generator();
  };

  const handleRefreshSingleCity = () => {
    setSearchText("");
    setTripCountry("");
    setSelectedRegion("Any");
    setDestination(SAMPLE_DESTINATIONS[0]);
    setShowMultiCityRooms(false);
    setRoomsOpen(true);
    setSelectedRoomId(null);
    setMultiCityRoomSelections({});
    setShowFullItinerary(false);
    setSingleCityRoomScope("global");
  };

  const handleRefreshMultiCity = () => {
    setMultiStops([createEmptyMultiStop()]);
    setMultiStartDate("");
    setShowMultiCityRooms(false);
    setActiveStopIndex(0);
    setBookedCityItineraries([]);
    setSelectedRoomId(null);
    setMultiCityRoomSelections({});
    setPinchyInventoryOpen(false);
    setShowFullItinerary(false);
  };

  const handleAddMultiStop = () => {
    setMultiStops((prev) => [
      ...prev,
      createEmptyMultiStop(),
    ]);
  };

  const handleRemoveMultiStop = (id) => {
    setMultiStops((prev) => {
      const next = prev.filter((item) => item.id !== id);
      return next.length ? next : [createEmptyMultiStop()];
    });
    setMultiCityRoomSelections((prev) => {
      const next = { ...prev };
      delete next[id];
      return next;
    });
  };

  const handleUpdateMultiStop = (id, field, value) => {
    setMultiStops((prev) => prev.map((item) => (item.id === id ? { ...item, [field]: value } : item)));
  };

  const handleStartPayment = () => {
    if (showMultiCityRooms) {
      if (!allMultiCityRoomsSelected) {
        setItineraryError("Select one room for each city before starting payment.");
        return;
      }

      const stopsWithRooms = roomCitiesForDisplay
        .map((stop) => {
          const roomId = multiCityRoomSelections[stop.id];
          const room = ROOM_LIBRARY.find((item) => item.id === roomId);
          const { checkInDate: stopCheckInDate, checkOutDate: stopCheckOutDate } = resolveStopDates(stop);
          if (!room || !stopCheckInDate || !stopCheckOutDate) return null;
          return {
            ...stop,
            checkInDate: stopCheckInDate,
            checkOutDate: stopCheckOutDate,
            room,
          };
        })
        .filter(Boolean);

      if (stopsWithRooms.length !== roomCitiesForDisplay.length) {
        setItineraryError("Each city needs a room and valid dates before payment.");
        return;
      }

      setPinchyInventoryOpen(false);
      setItineraryError("");
      return;
    }

    if (!selectedRoomId || !selectedRoom || !hasValidStayDates) {
      setItineraryError("Select a room and valid stay dates before starting payment.");
      return;
    }

    setPinchyInventoryOpen(false);
    setItineraryError("");
  };

  useEffect(() => {
    const activeBudget = budgetFilter === "Any" ? "Mid-range" : budgetFilter;
    setItineraryError("");
    setItineraryLoading(false);
    setItinerary({
      ...FALLBACK_ITINERARY,
      meta: {
        destination: `${destination.city}, ${destination.country}`,
        style: "Preview only (v2)",
        budget: activeBudget,
        interests: ["Food", "Culture", "Scenic"],
      },
    });
  }, [mode, destination.city, destination.country, budgetFilter, selectedRoomId, selectedRoom?.title, checkInDate, checkOutDate, hasValidStayDates, tripDays, normalizedMultiStops]);

  useEffect(() => {
    let cancelled = false;
    const activeBudget = budgetFilter === "Any" ? "Mid-range" : budgetFilter;
    const fallbackWeather = {
      temperature: getPreviewTemperature({ city: destination.city, budget: activeBudget }),
      mood: getWeatherMood(getPreviewTemperature({ city: destination.city, budget: activeBudget })),
    };

    const loadWeather = async () => {
      if (mode !== "live") {
        setLiveWeather(fallbackWeather);
        return;
      }

      try {
        const live = await fetchLiveWeatherSnapshot({ city: destination.city, country: destination.country });
        if (!cancelled) setLiveWeather(live || fallbackWeather);
      } catch {
        if (!cancelled) setLiveWeather(fallbackWeather);
      }
    };

    loadWeather();

    return () => {
      cancelled = true;
    };
  }, [mode, destination.city, destination.country, budgetFilter]);

  useEffect(() => {
    const updateCurrentPageFromHash = () => setCurrentPage(hashPageFromLocation());
    updateCurrentPageFromHash();
    window.addEventListener("hashchange", updateCurrentPageFromHash);
    return () => window.removeEventListener("hashchange", updateCurrentPageFromHash);
  }, []);

  if (currentPage !== "planner" && POLICY_CONTENT[currentPage]) {
    const policy = POLICY_CONTENT[currentPage];
    return (
      <div className="v2-shell v2-policy-shell">
        <div className="v2-panel v2-policy-panel">
          <div className="v2-policy-head">
            <h1>{policy.title}</h1>
            <button
              type="button"
              className="v2-policy-back"
              onClick={() => {
                window.location.hash = "";
              }}
            >
              Back to Planner
            </button>
          </div>
          <p>{policy.content}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="v2-shell">
      <header className="v2-hero">
        <div className="v2-hero-content">
          <img src={logo} alt="AppiHolidays logo" className="v2-hero-logo" />
          <div>
            <span className="v2-kicker">AppiHolidays V2</span>
            <h1>AppiHolidays</h1>
            <p>AI room booking with smart itineraries.</p>
            <div className="v2-mode-chip">Mode: {mode === "live" ? "Live API" : "Demo"}</div>
          </div>
        </div>
      </header>

      <main className="v2-main">
        <DestinationSelector
          destination={destination}
          setDestination={setDestination}
          searchText={searchText}
          setSearchText={setSearchText}
          filteredDestinations={filteredDestinations}
          selectedRegion={selectedRegion}
          setSelectedRegion={setSelectedRegion}
          onDestinationSelect={handleDestinationSelect}
          onGoFromSingleCity={handleGoFromSingleCity}
          onRefreshSingleCity={handleRefreshSingleCity}
          onRefreshMultiCity={handleRefreshMultiCity}
          tripCountry={tripCountry}
          setTripCountry={setTripCountry}
          numDays={numDays}
          setNumDays={setNumDays}
          singleStartDate={singleStartDate}
          setSingleStartDate={setSingleStartDate}
          multiStartDate={multiStartDate}
          setMultiStartDate={setMultiStartDate}
          checkInDate={checkInDate}
          checkOutDate={checkOutDate}
          setCheckOutDate={setCheckOutDate}
          budgetFilter={budgetFilter}
          setBudgetFilter={setBudgetFilter}
          multiStops={multiStops}
          multiStopDateRanges={multiStopDateRanges}
          onAddMultiStop={handleAddMultiStop}
          onRemoveMultiStop={handleRemoveMultiStop}
          onUpdateMultiStop={handleUpdateMultiStop}
          onGoToRooms={handleGoToRooms}
        />

        <section className={roomsFlash ? "v2-panel v2-panel-flash" : "v2-panel"} ref={roomsSectionRef}>
          <div className="v2-section-head">
            <div>
              <h2>
                {showMultiCityRooms
                  ? "Available rooms by city"
                  : singleCityRoomScope === "destination"
                    ? `Available rooms in ${destination.city}, ${destination.country}`
                    : "Available rooms across popular destinations"}
              </h2>
              <p>Preview options and lock your preferred room before trip details are revealed.</p>
            </div>
            <button
              type="button"
              className="v2-dropdown-toggle"
              onClick={() => setRoomsOpen((current) => !current)}
            >
              {roomsOpen ? "Hide rooms ▲" : "Show rooms ▼"}
            </button>
          </div>

          {!showMultiCityRooms && roomSelectionNotice ? (
            <div className="v2-select-room-notice" role="alert">{roomSelectionNotice}</div>
          ) : null}

          {roomsOpen ? (
            loadingRooms ? (
              <RoomsSkeleton />
            ) : filteredRooms.length > 0 ? (
              showMultiCityRooms && roomCitiesForDisplay.length > 0 ? (
                <>
                  <div className="v2-multi-progress" role="status" aria-live="polite">
                    Selected rooms: <strong>{multiCitySelectedCount}/{roomCitiesForDisplay.length}</strong>
                  </div>
                  <div className="v2-multi-room-lines">
                    {roomCitiesForDisplay.map((stop, stopIndex) => {
                    const stopDestination = resolveDestinationCard({ city: stop.city, country: stop.country });
                    const matchedMultiStop = normalizedMultiStops.find(
                      (item) =>
                        item.city.toLowerCase() === String(stop.city || "").toLowerCase() &&
                        item.country.toLowerCase() === String(stop.country || "").toLowerCase()
                    );
                    const resolvedCheckInDate = stop.checkInDate || matchedMultiStop?.checkInDate || "";
                    const resolvedCheckOutDate = stop.checkOutDate || matchedMultiStop?.checkOutDate || "";
                    return (
                      <section key={`${stop.city}-${stop.country}-${stopIndex}`} className="v2-room-line-block">
                        <h3 className="v2-room-line-head">
                          {stop.city}, {stop.country}
                          {resolvedCheckInDate && resolvedCheckOutDate ? ` (${resolvedCheckInDate} to ${resolvedCheckOutDate})` : ""}
                        </h3>
                        <div className="v2-room-line">
                          {filteredRooms.slice(0, 4).map((room) => (
                            <RoomCard
                              key={`${stop.city}-${room.id}`}
                              room={room}
                              selected={multiCityRoomSelections[stop.id] === room.id}
                              onSelect={(selected) => {
                                setItineraryError("");
                                const { checkInDate: stopCheckInDate, checkOutDate: stopCheckOutDate } = resolveStopDates(stop);
                                setMultiCityRoomSelections((prev) => ({
                                  ...prev,
                                  [stop.id]: selected.id,
                                }));
                                setActiveStopIndex(stopIndex);
                                setSelectedRoomId(selected.id);
                                setDestination(stopDestination);
                                setTripCountry(stop.country || "");
                                if (resolvedCheckInDate) setCheckInDate(resolvedCheckInDate);
                                if (resolvedCheckOutDate) setCheckOutDate(resolvedCheckOutDate);

                                const nextStop = roomCitiesForDisplay[stopIndex + 1];
                                if (nextStop) {
                                  const nextDestination = resolveDestinationCard({ city: nextStop.city, country: nextStop.country });
                                  const { checkInDate: nextCheckInDate, checkOutDate: nextCheckOutDate } = resolveStopDates(nextStop);
                                  setActiveStopIndex(stopIndex + 1);
                                  setDestination(nextDestination);
                                  setTripCountry(nextStop.country || "");
                                  setSearchText(nextStop.city || "");
                                  if (nextCheckInDate) setCheckInDate(nextCheckInDate);
                                  if (nextCheckOutDate) setCheckOutDate(nextCheckOutDate);
                                } else {
                                  if (stopCheckInDate) setCheckInDate(stopCheckInDate);
                                  if (stopCheckOutDate) setCheckOutDate(stopCheckOutDate);
                                }
                              }}
                            />
                          ))}
                        </div>
                      </section>
                    );
                    })}
                  </div>
                </>
              ) : (
                <div className="v2-room-list">
                  {filteredRooms.map((room, roomIndex) => {
                    const globalDestinations = filteredDestinations.length > 0 ? filteredDestinations : SAMPLE_DESTINATIONS;
                    const mappedDestination = globalDestinations[roomIndex % globalDestinations.length] || destination;
                    const destinationLabel = singleCityRoomScope === "destination"
                      ? `${destination.city}, ${destination.country}`
                      : `${mappedDestination.city}, ${mappedDestination.country}`;
                    return (
                      <RoomCard
                        key={room.id}
                        room={room}
                        selected={room.id === selectedRoomId}
                        onSelect={handleRoomSelect}
                        destinationLabel={destinationLabel}
                      />
                    );
                  })}
                </div>
              )
            ) : (
              <div className="v2-empty-state">No rooms matched these filters. Try widening price or budget.</div>
            )
          ) : (
            <div className="v2-empty-state">Rooms are hidden. Use the dropdown button to expand this section.</div>
          )}

          <div className="v2-see-more-wrap">
            <button type="button" className="v2-see-more-btn" onClick={handleSeeMoreRooms}>See More Rooms</button>
          </div>

          {showMultiCityRooms && allMultiCityRoomsSelected ? (
            <div className="v2-see-more-wrap">
              <button
                type="button"
                className="v2-go-rooms-btn"
                onClick={() => {
                  const lastStop = roomCitiesForDisplay[roomCitiesForDisplay.length - 1];
                  if (lastStop) {
                    const lastRoomId = multiCityRoomSelections[lastStop.id];
                    const lastRoom = ROOM_LIBRARY.find((item) => item.id === lastRoomId);
                    const { checkInDate: lastCheckInDate, checkOutDate: lastCheckOutDate } = resolveStopDates(lastStop);
                    if (lastRoom) setSelectedRoomId(lastRoom.id);
                    setDestination(resolveDestinationCard({ city: lastStop.city, country: lastStop.country }));
                    setTripCountry(lastStop.country || "");
                    if (lastCheckInDate) setCheckInDate(lastCheckInDate);
                    if (lastCheckOutDate) setCheckOutDate(lastCheckOutDate);
                  }
                  setPinchyInventoryOpen(true);
                }}
              >
                Start Payment
              </button>
            </div>
          ) : null}
        </section>

        <div ref={itinerarySectionRef}>
          <ItineraryPreview
            itinerary={itinerary}
            loading={itineraryLoading}
            error={itineraryError}
            mode={mode}
            liveWeather={liveWeather}
            selectedRoom={selectedRoom}
            tripDays={tripDays}
            destination={destination}
            bookedCityItineraries={bookedCityItineraries}
          />
        </div>

        <section className="v2-panel v2-summary">
          <h2>Selection summary</h2>
          <p>
            Booking step: <strong>{Math.min(activeStopIndex + 1, bookingFlowStops.length)}</strong> of <strong>{bookingFlowStops.length}</strong>
          </p>
          <p>
            Destination: <strong>{destination.city}, {destination.country}</strong>
          </p>
          {normalizedMultiStops.length > 0 ? (
            <p>
              Extra cities: <strong>{normalizedMultiStops.map((item) => `${item.city}, ${item.country}`).join(" | ")}</strong>
            </p>
          ) : null}
          <p>
            Room: <strong>{selectedRoom ? selectedRoom.title : "Not selected"}</strong>
          </p>
          <p>
            Budget: <strong>{budgetFilter === "Any" ? "Mid-range" : budgetFilter}</strong> | Nights: <strong>{hasValidStayDates ? tripDays : "-"}</strong>
          </p>
          <p>
            Stay: <strong>{checkInDate || "Select check-in"}</strong> to <strong>{checkOutDate || "Select check-out"}</strong>
          </p>
          {bookedCityItineraries.length > 0 ? (
            <p>
              Generated city itineraries: <strong>{bookedCityItineraries.map((item) => item.city).join(", ")}</strong>
            </p>
          ) : null}
          <button type="button" onClick={handleContinueToItinerary}>Generate Full Itinerary (v1)</button>
        </section>

        {showFullItinerary ? (
          <div ref={fullItinerarySectionRef}>
            <FullItineraryView
              itinerary={itinerary}
              bookedCityItineraries={bookedCityItineraries}
              destination={destination}
              liveWeather={liveWeather}
            />
          </div>
        ) : null}

        <footer className="v2-footer">
          <p>© {new Date().getFullYear()} AppiHolidays.com.</p>
          <div className="v2-footer-links">
            {[
              { hash: "privacy", label: "Privacy Policy" },
              { hash: "cookies", label: "Cookies Policy" },
              { hash: "security", label: "Security Policy" },
              { hash: "about", label: "About AppiHolidays.com" },
            ].map((item) => (
              <a
                key={item.hash}
                href={`#${item.hash}`}
                onClick={(event) => {
                  event.preventDefault();
                  window.location.hash = item.hash;
                }}
              >
                {item.label}
              </a>
            ))}
          </div>
        </footer>

        <PinchyInventoryPanel
          open={pinchyInventoryOpen}
          onClose={() => setPinchyInventoryOpen(false)}
          destination={destination}
          selectedRoom={selectedRoom}
          selectedRoomEntries={showMultiCityRooms ? multiCitySelectedRoomEntries : []}
          budget={budgetFilter === "Any" ? "Mid-range" : budgetFilter}
          days={tripDays}
          checkInDate={checkInDate}
          checkOutDate={checkOutDate}
          mode={mode}
          onSelectRoom={setSelectedRoomId}
          onStartPayment={handleStartPayment}
        />
      </main>
    </div>
  );
}
